import React, { CSSProperties, FC, useState } from 'react';
import { Handle, NodeProps, Position } from 'react-flow-renderer';
import { Flex } from '..';
import { DIAGRAM_SOFTWARE_COLORS, ELEMENT_TYPE } from '../../constants/diagram';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { removeDiagramElements } from '../../redux/slices/diagramSlice';
import { getColor } from '../../styles/mixins';
import { cloneObject } from '../../utils';
import { DeleteNode, TableNodeStyle, DeleteIcon } from './TableNode.styled';

const TableNode: FC<NodeProps> = ({ id, data, isConnectable }) => {
  const dispatch = useAppDispatch();
  const diagram = useAppSelector((state) => state.diagramR);
  const nodeColor = DIAGRAM_SOFTWARE_COLORS[diagram.diagram_software_type];
  const [showDeleteTableIcon, setShowDeleteTableIcon] = useState(false);

  const NodeStyle: CSSProperties = {
    backgroundColor: getColor(nodeColor),
    height: '8px',
    width: '48px',
    borderRadius: '4px',
  };

  const sourceHandleStyle: CSSProperties = {
    ...NodeStyle,
    bottom: '-15px',
  };

  const targetHandleStyle: CSSProperties = {
    ...NodeStyle,
    height: '20px',
    width: '8px',
    left: '-15px',
  };

  const onDeleteNode = () => {
    if (isConnectable) {
      const tableElement = cloneObject(data);
      tableElement.type = ELEMENT_TYPE.TABLE;
      tableElement.id = id;
      dispatch(removeDiagramElements([tableElement]));
    }
  };

  return (
    <>
      <Handle
        type="target"
        position={Position.Left}
        id="TableTarget"
        style={targetHandleStyle}
        isConnectable={isConnectable}
      />
      <DeleteNode
        onClick={onDeleteNode}
        onMouseOver={() =>
          isConnectable ? setShowDeleteTableIcon(true) : null
        }
        onMouseLeave={() =>
          isConnectable ? setShowDeleteTableIcon(false) : null
        }
      >
        <DeleteIcon showDeleteTableIcon={showDeleteTableIcon} />
      </DeleteNode>
      <TableNodeStyle
        nodeColor={nodeColor}
        onMouseOver={() =>
          isConnectable ? setShowDeleteTableIcon(true) : null
        }
        onMouseLeave={() =>
          isConnectable ? setShowDeleteTableIcon(false) : null
        }
      >
        <Flex justifyContent="center" py="8px">
          {data.name}
        </Flex>
      </TableNodeStyle>
      <Handle
        type="source"
        position={Position.Bottom}
        id="TableSource"
        style={sourceHandleStyle}
        isConnectable={isConnectable}
      />
    </>
  );
};

export default TableNode;
